import React from 'react';
import './styles.scss';

class Contact extends React.Component {
	render() {
		return (
			<main id="contact" className="main contact">
				<h1>Contacto</h1>
			</main>
		)
	}
};

export default Contact;